import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=3328fdb5&lang=html&"
import script from "./ContactFooter.vue?vue&type=script&lang=js&"
export * from "./ContactFooter.vue?vue&type=script&lang=js&"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports